/**
 * @desc: 筛选器类型常量定义
 */

/**
 * 筛选器类型键常量
 * 每个键对应一个渲染器注册条目
 * 仅保留当前已实现并可用的控件类型
 */
export const FILTER_TYPE = {
  RANGE_PICKER: 'range_picker',
  REGION_SELECT: 'region_select',
  GENRE_SELECT: 'genre_select',
  GAME_SELECT: 'game_select',
  COMPANY_SELECT: 'company_select',
  PUBLISHER_CLASS_SELECT: 'publisher_class_select',
  MULTIPLE_SELECT: 'multiple_select',
  TAG_SELECT: 'tag_select',
  SENSOR_TOWER_THEME: 'sensortower_theme_tag_select',
  NUMBER_RANGE: 'number_range',
  REVENUE_RANGE: 'revenue_range',
  REVENUE_GROWTH: 'revenue_growth',
  DATA_SOURCE: 'data_source',
  PLATFORM: 'platform',
  GAME_ENGINE: 'game_engine',
} as const;
